import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

import { UserProvider } from './context/UserContext';

// Restaurant Header and Footer
import Header from './restaurant/Header';
import Footer from './restaurant/Footer';

// Restaurant Pages
import Signup from './restaurant/Signup'
import Signin from './restaurant/Signin';
import Home from './restaurant/Home';
import Supervisor from './restaurant/Supervisor';
import OrderDetails from './restaurant/OrderDetails';
import Profile from './restaurant/Profile';
import UnnoticedPassword from './restaurant/RestaurantForgotpassword'

// organization Pages
import OrganizationRegister from './organization/SignUp';
import OrganizationLogin from './organization/SignIn';
import Organization from './organization/Header'; 
import AddorganizationHomePage from './organization/OrganizationHome';
import Support from './organization/Support';
import Forgotpasswords from './organization/ForgotPassword';
import EmployeeHomePage from './organization/Employee';
import Dashboard from './organization/Dashboard';

// School Book
import ClassBookHome from './classbook/Homepage/ClassBookHome';
import ClassBookNavbar from './classbook/ClassBookNavbar/ClassBookNavabar';
import ClassBookProfile from './classbook/ClassBookProfilePage/ClassBookProfile';
import SearchSchools from './classbook/SearchSchools/SearchSchools';
import SearchFriends from './classbook/SearchFriends/SearchFriends';
import CBDashboard from './classbook/ClassBookDashBoardPage/CBDashBoard';
import ProfileUpdate from './classbook/ProfileUpdate/ProfileUpdate';
import MyFriends from './classbook/MyFriends/MyFriends';
import MySchools from './classbook/MySchools/MySchools';
import AddClass from './classbook/AddClass/AddClass';
import Teachers from './classbook/Teachers/Teachers';
import Videos from './classbook/Videos/Videos';
import Photos from './classbook/Photos/Photos';
import Comments from './classbook/Comments/Comments';

import './App.css'

// FCM - Firebase
//import { requestPermissionAndSendToken, setupForegroundNotification } from "./firebase-config";


const App = () => {

  //FCM - Firebase - STEP1
  /*
  if ('serviceWorker' in navigator && 'PushManager' in window) {//

    console.log('app.App:Service Worker registered with scope');

    navigator.serviceWorker.register('/firebase-messaging-sw.js')
      .then(function(registration) {
        console.log('app.App:Service Worker registered with scope:', registration.scope);
  
        // Request push notification permission
        Notification.requestPermission().then(permission => {
          if (permission === 'granted') {
            console.log('Notification permission granted!');
            // Now subscribe to push notifications (You can handle subscription logic here)
          }
        });
      })
      .catch(function(error) {
        console.error('Service Worker registration failed:', error);
      });
  } //fcm
  */

  return (
    <UserProvider>
      <Router>
        <Main />
        {/* Class Book */}
        {/* <ClassBookNavbar/>
        <Routes>
           
          
           <Route path='/' element={<ClassBookHome/>} />
             <Route path='/searchschools' element={<SearchSchools/>} />
           <Route path='/searchfriend' element={<SearchFriends/>} /> 
           <Route path='/classBookProfile' element={<ClassBookProfile/>} />
           <Route path='/classBookDashboard' element={<CBDashboard/>} />
           <Route path='/profileUpdate' element={<ProfileUpdate/>} />
           <Route path='/myFriends' element={<MyFriends/>} />
           <Route path='/mySchools' element={<MySchools/>} />
           <Route path='/addClass' element={<AddClass/>} />
           <Route path='/teachers' element={<Teachers/>} />
           <Route path='/videos' element={<Videos/>} />
           <Route path='/photos' element={<Photos/>} />
           <Route path='/comments' element={<Comments/>} />
        </Routes> */}
      </Router>
    </UserProvider>
  );

};//App

const Main = () => {

  //FCM - Firebase - STEP2
  /*
  useEffect(() => { //firebase.js
    console.log('app.App:Main:useEffect:[requestPermissionAndSendToken, setupForegroundNotification]')
    requestPermissionAndSendToken(); // Request permission and send the token
    setupForegroundNotification(); // Set up foreground notification handler ???
  }, []);
  */
  const location = useLocation(); // Access current route
  // const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return localStorage.getItem("isAuthenticated") === "true"; // 
  });
  
  
  const [isRegistered, setIsRegistered] = useState(false);
  // eslint-disable-next-line
  const [notification, setNotification] = useState(null); //fcm-firebase

  const handleLogin = () => {
    setIsAuthenticated(true);
    localStorage.setItem("isAuthenticated", "true"); // 
  };

  const handleRegistrationSuccess = () => {
    setIsRegistered(true);
    console.log('isRegistered:', isRegistered);
  };


  // Check if the current route is for restaurant pages (and not sign-in or sign-up)
  // eslint-disable-next-line
  const isRestaurantRoute = location.pathname.includes('/restaurant');
  const isorganizationRoute = location.pathname.includes('/organization');

  // Determine whether to show header and footer for restaurant pages
  const isRestaurantAuthPage = 
    location.pathname === '/restaurant/signin' ||
    location.pathname === '/restaurant/signup' ||
    location.pathname === '/restaurant/forgotpassword' ||
    location.pathname === '/restaurant/support';

  const showHeaderFooter = 
    !isorganizationRoute &&// Don't show on organization pages
    !isRestaurantAuthPage  && // Don't show on restaurant sign-in/sign-up pages
    location.pathname !== '/'; // Also exclude the root path

  return (
    <div>
       
    
      {/* Conditionally render Header for restaurant pages, excluding sign-in, sign-up and root */}
      {showHeaderFooter && (
          <Header isAuthenticated={isAuthenticated} />
      )}

     
      {notification && (
        alert('Notification::App: '+notification.body)
      )}
    
      <Routes>        
        {/* Organization Authentication Routes */}
          <Route path="/organization/signup" element={<OrganizationRegister onSuccess={handleRegistrationSuccess} onLogin={handleLogin} />} />
          <Route path="/organization/signin" element={<OrganizationLogin onLogin={handleLogin} />} />
          <Route path='/organization/forgotpassword' element={<Forgotpasswords/>} />

         

          {/* Organization Routes should always be accessible */}
          <Route path="/organization/*" element={<Organization isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />}>
            <Route path="dashboard" element={isAuthenticated ? <Dashboard /> : <OrganizationLogin onLogin={handleLogin} />} />
            <Route path="add" element={isAuthenticated ? <AddorganizationHomePage /> : <OrganizationLogin onLogin={handleLogin} />} />
            <Route path="employee" element={isAuthenticated ? <EmployeeHomePage /> : <OrganizationLogin onLogin={handleLogin} />} />
            <Route path="support" element={<Support />} />
          
          </Route>
        

        {/* Restaurant Routes */}
        <Route path="/restaurant/signup" element={<Signup />} />
        <Route path="/restaurant/signin" element={<Signin onLogin={handleLogin} />} />

        <Route path="/home" element={<Home />} />
        <Route path="/supervisor" element={<Supervisor />} />
        <Route path="/OrderDetails/:restaurantId/:orderId" element={<OrderDetails />} />
        <Route path="/profile" element={<Profile />} />
        <Route path='/restaurant/forgotpassword' element={<UnnoticedPassword/>} />
        <Route path="/restaurant/support" element={<Support/>} />
      </Routes>
    
      {/* Conditionally render Footer for restaurant pages, excluding sign-in, sign-up and root */}
      {showHeaderFooter && 
      <Footer />}
    
    </div>
   
  );
};

export default App;
